import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import FacebookIcon from '@material-ui/icons/Facebook';
import MuiButton from '@material-ui/core/Button';
import config from '../../config/config.json';
import { colors, borderRadius, fontSize, border } from '../../constants/styleConstants';
import GoogleIcon from '../../public/images/icons/google.png';
import { PRODUCTION_MODE } from '../../constants/consts';
import route from '../../constants/routes';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(theme => ({
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    padding: 8,
    minHeight: 40,
    height: 'auto',
    marginBottom: 12,
    justifyContent: 'flex-start',
    textTransform: 'none',

    borderRadius: borderRadius.button,
    border: border.lightGrey,
  },
  label: {
    alignItems: 'center',
    color: colors.websiteLinkColor,
    fontSize: fontSize.medium,
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  googleIcon: {
    backgroundColor: colors.white,
    borderRadius: borderRadius.button,
    marginRight: 19,
    height: 20,
    '& img': {
      height: '100%',
    },
  },
  facebookButton: {},
  facebookIcon: {
    marginRight: 19,
    fill: colors.fbBlue,
    height: '100%',
    fontSize: fontSize.h3,
  },
}));

const SocialSignInButtons = ({ type }) => {
  const classes = useStyles();

  const authLink = name =>
    PRODUCTION_MODE
      ? `${config.FUSION_API_PUBLIC_HOST}/auth/${name}/auth?ref=${config.FRONTBASE_URL}${route.LOGIN}`
      : '';

  return (
    <div className={classes.buttonsWrapper}>
      {process.env.THIRDPARTY_LOGINS?.includes('google') && (
        <MuiButton
          href={authLink('google')}
          classes={{
            root: classes.button,
            label: classes.label,
          }}
        >
          <div className={classes.googleIcon}>
            <ImageTag src={GoogleIcon} alt="Google icon" />
          </div>
          {type} Google
        </MuiButton>
      )}
      {process.env.THIRDPARTY_LOGINS?.includes('facebook') && (
        <MuiButton
          href={authLink('facebook')}
          classes={{
            root: classnames(classes.button, classes.facebookButton),
            label: classes.label,
          }}
        >
          <FacebookIcon className={classes.facebookIcon} />
          {type} Facebook
        </MuiButton>
      )}
    </div>
  );
};

SocialSignInButtons.propTypes = {
  type: PropTypes.string,
};

export default SocialSignInButtons;
